import moment from 'moment-timezone'

export const getFromWeekCinemaStartDate = (week, year) => moment(String(year)).isoWeek(week).isoWeekday(4)

export const getFromWeekCinemaEndDate = (week, year) => moment(String(year)).isoWeek(week).isoWeekday(3).add(7, 'days')
